export enum DataResultStyle {
	RAW,
	RecordBased,
}
